import React from "react";
import { stylex } from "./stylex";

interface RowProps {
  children?: React.ReactNode;
  justifyContent?:
    | "flex-start"
    | "flex-end"
    | "space-between"
    | "space-around"
    | "center";
  alignItems?: "flex-start" | "flex-end" | "space-between" | "center";
  expanded?: boolean;
  flex?: number;
  overflow?: "hidden" | "visible";
  wrap?: boolean;
  ltr?: boolean;
  rtl?: boolean;
  testID?: string;
}

/**
 * Displays its children in a horizontal array.
 */
export function Row(props: RowProps) {
  const {
    children,
    overflow,
    justifyContent,
    alignItems,
    expanded,
    flex,
    wrap,
    ltr = true,
    rtl = false,
    testID,
  } = props;

  return (
    <div
      data-testid={testID}
      style={{
        ...styles(
          "base",
          expanded && "expanded",
          wrap && "wrap",
          wrap && rtl && "wrapReverse",
          ltr && "ltr",
          rtl && "rtl"
        ),
        justifyContent,
        alignItems,
        overflow,
        flex,
      }}
    >
      {children}
    </div>
  );
}

const styles = stylex.create({
  base: {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    boxSizing: "border-box",
  },
  expanded: { height: "100%", width: "100%" },
  wrap: {
    flexWrap: "wrap",
  },
  wrapReverse: {
    flexWrap: "wrap-reverse",
  },

  rtl: {
    flexDirection: "row-reverse",
  },
  ltr: {
    flexDirection: "row",
  },
});
